import { defineStore } from "pinia";

import authService from "../../service/auth/auth.service";
import { storeItem } from "../../core/utils/storage.helper";
import {
  Register,
  Login,
  ForgotPasswordInit,
  ForgotPasswordComplete,
  ChangePassword,
  ResetPassword,
  Update,
} from "../../service/auth/interface/auth.interface";
import isAuthenticated from "../../core/helpers/authenticate";
import isAuthenticateed from "../../core/helpers/authenticated";
import userService from "../../service/user/user.service";

const isIdentity = isAuthenticated();
const isIdentityy = isAuthenticateed();

const authStore = defineStore("auth", {
  state: () => {
    return {
      isAuthenticated: isIdentity,
      isAuthenticateed: isIdentityy,
      user: null as null | {
      firstName: string;
      lastName: string;
      email: string;
      organisationName?: string;
      organisationId?: number;
      userId?: number;
      imageUrl?: string;
      role?: 'employee' | 'organisation';
      phone?: string;
    },
      customerReg: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
      },
      userLogin: {
        email: "",
      },
      successMessage: null,
      errorMessage: null,
    };
  },
  actions: {
   
async autoLoginWithToken(token: string, orgId: string, userId: string): Promise<any> {
  try {
    // Store the token
    storeItem(import.meta.env.VITE_ACCESSTOKEN, { rsa: token });
    localStorage.setItem('userId', userId);

    // Fetch user details
    const userResponse = await userService.show(Number(userId));
    const userData = userResponse.data?.data;
    console.log("userData===========", userData);
    if (!userData) throw new Error('Failed to fetch user details');

    let customerInfo;

    if (userData.organisation) {
      customerInfo = {
        firstName: userData.organisation.user.firstname,
        lastName: userData.organisation.user.lastname,
        email: userData.organisation.user.email,
        organisationName: userData.organisation.organisationName,
        organisationId: userData.organisation.id,
        userId: userData.organisation.userId,
        imageUrl: userData.organisation.user?.imageUrl || '',
        role: 'organisation' as 'organisation',
      };
    } else if (userData.employee) {
      customerInfo = {
        firstName: userData.employee.user.firstname,
        lastName: userData.employee.user.lastname,
        email: userData.employee.user.email,
        organisationName: userData.employee.organisation.organisationName,
        organisationId: userData.employee.organisation.id,
        userId: userData.employee.userId,
        imageUrl: userData.employee.user?.imageUrl || '',
        role: 'employee' as 'employee',
      };
    } else {
      throw new Error('Unknown user type');
    }

    // Validate organisation ID
    if (!customerInfo.organisationId || customerInfo.organisationId !== Number(orgId)) {
      throw new Error('Organization mismatch');
    }

    // Store user info in localStorage consistently as object
    storeItem(import.meta.env.VITE_USERDETAILS, { customerInfo });

    // Update store state
    this.isAuthenticateed = true;
    this.user = customerInfo;

    return Promise.resolve(userResponse);
  } catch (error) {
    this.clearAuth();
    return Promise.reject(error);
  }
},

async userLoginn(data: Login): Promise<any> {
  try {
    const response = await authService.loginn(data);

    if (response && response.data && response.data.data.token) {
      const token = response.data.data.token;
      const userId = response.data.data.id;

      // Store token
      storeItem(import.meta.env.VITE_ACCESSTOKEN, { rsa: token });
      localStorage.setItem('userId', userId.toString());

      // Fetch user details
      const userDetailsResponse = await userService.show(userId);
      if (userDetailsResponse?.status === 404) {
        throw new Error('Account not found. Please contact support.');
      }
      const userData = userDetailsResponse.data?.data;
      if (!userData) throw new Error('Unable to load account details. Please try again.');

      let customerInfo;

      if (userData.organisation) {
        customerInfo = {
          firstName: userData.organisation.user.firstname,
          lastName: userData.organisation.user.lastname,
          email: userData.organisation.user.email,
          phone: userData.organisation.user.phone,
          organisationName: userData.organisation.organisationName,
          organisationId: userData.organisation.id,
          userId: userData.organisation.userId,
          imageUrl: userData.organisation.user?.imageUrl || '',
          role: 'organisation' as 'organisation',
        };
      } else if (userData.employee) {
        customerInfo = {
          firstName: userData.employee.user.firstname,
          lastName: userData.employee.user.lastname,
          email: userData.employee.user.email,
          phone: userData.employee.user.phone,
          organisationName: userData.employee.organisation.organisationName,
          organisationId: userData.employee.organisation.id,
          userId: userData.employee.userId,
          imageUrl: userData.employee.user?.imageUrl || '',
          role: 'employee' as 'employee',
        };
      } else {
        throw new Error('Unknown user type');
      }

      // Store user info consistently as object
      storeItem(import.meta.env.VITE_USERDETAILS, { customerInfo });

      // Update store state
      this.isAuthenticateed = true;
      this.user = customerInfo;

      return Promise.resolve(response);
    } else if (response.response) {
      return Promise.reject(response.response);
    } else {
      return Promise.reject(response);
    }
  } catch (error: any) {
    this.clearAuth();
    return Promise.reject(error);
  }
},


  clearAuth() {
    sessionStorage.removeItem(import.meta.env.VITE_ACCESSTOKEN);
    sessionStorage.removeItem(import.meta.env.VITE_USERDETAILS);
    sessionStorage.removeItem(import.meta.env.VITE_ACCESSTK);
    localStorage.removeItem('userId');
    localStorage.removeItem('mainOrganisationUserId');

    this.isAuthenticateed = false;
    this.isAuthenticated = false;
    this.user = null;
  },
  
    // async userLoginn(data: Login): Promise<any> {
    //   try {
    //     const response = await authService.loginn(data);
    
    //     if (response && response.data && response.data.data.token) {
    //       const token = response.data.data.token;
    //       const userId = response.data.data.id; 
    
    //       storeItem(import.meta.env.VITE_ACCESSTOKEN, { rsa: token });
    
    //       // Fetch additional user details
    //       const userDetailsResponse = await userService.show(userId);
          
    //       // Handle the user details response
    //       if (userDetailsResponse && userDetailsResponse.data) {
    //         console.log("////////////", userDetailsResponse.data)
    //         // Store user details in local storage or state
    //         const userData = JSON.stringify({
    //           customerInfo: {
    //             firstName: userDetailsResponse.data.data.organisation.user.firstname,
    //             lastName: userDetailsResponse.data.data.organisation.user.lastname,
    //             email: userDetailsResponse.data.data.organisation.user.email,
    //             phone: userDetailsResponse.data.data.organisation.user.phone,
    //             // wallet: userDetailsResponse.data.data.organisation.wallet.balance,
    //             organisationName: userDetailsResponse.data.data.organisation.organisationName,
    //             organisationId: userDetailsResponse.data.data.organisation.id,
    //           },
    //         });
    
    //         storeItem(import.meta.env.VITE_USERDETAILS, userData);
    //       }
    
    //       this.isAuthenticateed = true;
    //       return await Promise.resolve(response);
    //     } else if (response.response) {
    //       return await Promise.reject(response.response);
    //     } else {
    //       return await Promise.reject(response.message);
    //     }
    //   } catch (error: any) {
    //     return await Promise.reject(error);
    //   }
    // },
 
    async updateProfile(data: any): Promise<any> {
      try {
        const response = await authService.updateProfile(data);
    
        if (response && response.data && response.data.succeeded) {
          console.log(response.data.message); 
    
          // clear or refresh user details here if needed
          return response;
        } else {
          return Promise.reject(response.data.message || "Update failed");
        }
      } catch (error: any) {
        return Promise.reject(error);
      }
    },    
    async changeThePassword(data: {
      currentPassword: string;
      newPassword: string;
    }): Promise<any> {
      try {
        const response = await authService.changeThePassword(data);
    
        if (response && response.data && response.data.succeeded) {
          return response;
        } else {
          return Promise.reject(response);
        }
      } catch (error: any) {
        return Promise.reject(error);
      }
    },    
    // async userRegister(data: Register): Promise<any> {
    //   try {
    //     const response = await authService.register(data);
    //     if (response.data) {
    //       return await Promise.resolve(response);
    //     } else if (response.response) {
    //       return await Promise.reject(response.response);
    //     } else {
    //       return await Promise.reject(response.message);
    //     }
    //   } catch (error: any) {
    //     return await Promise.reject(error);
    //   }
    // },
    async userRegister(data: Register): Promise<any> {
      try {
        const response = await authService.register(data);
        if (response.data) {
          // Send email confirmation link
          await this.sendEmailConfirmationLink(data.email);
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        console.error("userRegister error:", error);
        return await Promise.reject(error);
      }
    },
    
    async sendEmailConfirmationLink(email: string): Promise<any> {
      try {
        const response = await authService.sendEmailConfirmationLink({ email });
        return await Promise.resolve(response);
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },    
    async userForgotPasswordInit(email: string): Promise<any> {
      try {
        const response = await authService.forgotPasswordInit(email);

        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        // console.log("error:", error);
        return await Promise.reject(error);
      }
    },
    async signInWithGoogle(tke: string,response:any): Promise<any> {
      storeItem(import.meta.env.VITE_ACCESSTK, {
        rsa: tke,
      });

      const data = {
        customerInfo: {
          firstName: response.data.data.firstname,
          lastName: response.data.data.lastname,
          email: response.data.data.email,
          phone: response.data.data.phone,
        },
      };

      storeItem(import.meta.env.VITE_USERDETAILS, data);
      this.isAuthenticated = true;

    },
    async forgotPasswordComplete(data: any): Promise<any> {
      try {
        const response = await authService.forgotPasswordComplete(data);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async userResetPassword(data: ResetPassword): Promise<any> {
      try {
        const response = await authService.resetPassword(data);

        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },

    async confirmEmail(data: { email: string; token: string }): Promise<any> {
      try {
        const response = await authService.confirmEmail(data);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },

    async registerEmployee(data: { inviteId: string; password: string }): Promise<any> {
      try {
        const response = await authService.registerEmployee(data);

        if (response && response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        console.error("Error submitting KYC documents:", error);
        return await Promise.reject(error);
      }
    },
    // async changePassword(data: any): Promise<any> {
    //   try {
    //     const response = await authService.changePassword(data);
    //     if (response.data) {
    //       return await Promise.resolve(response);
    //     } else if (response.response) {
    //       return await Promise.reject(response.response);
    //     } else {
    //       return await Promise.reject(response.message);
    //     }
    //   } catch (error: any) {
    //     return await Promise.reject(error);
    //   }
    // },

    async logoutUser(): Promise<any> {
      try {
        const response = await authService.logout();
        if (response && response.status === 200) {
          this.clearAuth();
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
    async getProfile(): Promise<any> {
      try {
        const response = await authService.profile();
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
   
    // async updateProfile(data: Update): Promise<any> {
    //   try {
    //     const response = await authService.updateProfile(data);

    //     if (response.data) {
    //       return await Promise.resolve(response);
    //     } else if (response.response) {
    //       return await Promise.reject(response.response);
    //     } else {
    //       return await Promise.reject(response.message);
    //     }
    //   } catch (error: any) {
    //     return await Promise.reject(error);
    //   }
    // },
  },
});

export default authStore;




















// import { defineStore } from "pinia";

// import authService from "../../service/auth/auth.service";
// import { storeItem } from "../../core/utils/storage.helper";
// import {
//   Register,
//   Login,
//   ForgotPasswordInit,
//   ForgotPasswordComplete,
//   ChangePassword,
//   Update,
// } from "../../service/auth/interface/auth.interface";
// import isAuthenticated from "../../core/helpers/authenticate";

// const isIdentity = isAuthenticated();

// const authStore = defineStore("auth", {
//   state: () => {
//     return {
//       isAuthenticated: isIdentity,
//       customerReg: {
//         firstName: "",
//         lastName: "",
//         email: "",
//         phone: "",
//       },
//       userLogin: {
//         email: "",
//       },
//       successMessage: null,
//       errorMessage: null,
//     };
//   },
//   actions: {
//     async userLogin(data: Login): Promise<any> {
//       try {
//         const response = await authService.login(data);

//         if (response && response.data && response.data.access_token) {
//           // console.log(response.data);
      
//           storeItem(import.meta.env.VITE_ACCESSTK, {
//             rsa: response.data.access_token,
//           });

//           const data = JSON.stringify({
//             customerInfo: {
//               firstName: response.data.data.firstname,
//               lastName: response.data.data.lastname,
//               email: response.data.data.email,
//               phone: response.data.data.phone,
//             },
//           });

//           storeItem(import.meta.env.VITE_USERDETAILS, data);
//           this.isAuthenticated = true;

//           return await Promise.resolve(response);
//         } else if (response.response) {
//           return await Promise.reject(response.response);
//         } else {
//           return await Promise.reject(response.message);
//         }
//       } catch (error: any) {
//         // console.log(error);
//         return await Promise.reject(error);
//       }
//     },
//     async userRegister(data: Register): Promise<any> {
//       try {
//         const response = await authService.register(data);
//         if (response.data) {
//           return await Promise.resolve(response);
//         } else if (response.response) {
//           return await Promise.reject(response.response);
//         } else {
//           return await Promise.reject(response.message);
//         }
//       } catch (error: any) {
//         return await Promise.reject(error);
//       }
//     },
//     async userForgotPasswordInit(data: ForgotPasswordInit): Promise<any> {
//       try {
//         const response = await authService.forgotPasswordInit(data);

//         if (response.data) {
//           return await Promise.resolve(response);
//         } else if (response.response) {
//           return await Promise.reject(response.response);
//         } else {
//           return await Promise.reject(response.message);
//         }
//       } catch (error: any) {
//         // console.log("error:", error);
//         return await Promise.reject(error);
//       }
//     },
//     async signInWithGoogle(tke: string,response:any): Promise<any> {
//       storeItem(import.meta.env.VITE_ACCESSTK, {
//         rsa: tke,
//       });

//       const data = JSON.stringify({
//         customerInfo: {
//           firstName: response.data.data.firstname,
//           lastName: response.data.data.lastname,
//           email: response.data.data.email,
//           phone: response.data.data.phone,
//         },
//       });

//       storeItem(import.meta.env.VITE_USERDETAILS, data);
//       this.isAuthenticated = true;

//     },
//     async forgotPasswordComplete(data: any): Promise<any> {
//       try {
//         const response = await authService.forgotPasswordComplete(data);
//         if (response.data) {
//           return await Promise.resolve(response);
//         } else if (response.response) {
//           return await Promise.reject(response.response);
//         } else {
//           return await Promise.reject(response.message);
//         }
//       } catch (error) {
//         return await Promise.reject(error);
//       }
//     },
//     async changePassword(data: any): Promise<any> {
//       try {
//         const response = await authService.changePassword(data);
//         if (response.data) {
//           return await Promise.resolve(response);
//         } else if (response.response) {
//           return await Promise.reject(response.response);
//         } else {
//           return await Promise.reject(response.message);
//         }
//       } catch (error: any) {
//         return await Promise.reject(error);
//       }
//     },

//     async logoutUser(): Promise<any> {
//       try {
//         const response = await authService.logout();
//         if (response.data) {
//           this.isAuthenticated = false;
//           sessionStorage.clear();
//           return await Promise.resolve(response);
//         } else if (response.response) {
//           return await Promise.reject(response.response);
//         } else {
//           return await Promise.reject(response.message);
//         }
//       } catch (error: any) {
//         return await Promise.reject(error);
//       }
//     },
//     async getProfile(): Promise<any> {
//       try {
//         const response = await authService.profile();
//         if (response.data) {
//           return await Promise.resolve(response);
//         } else if (response.response) {
//           return await Promise.reject(response.response);
//         } else {
//           return await Promise.reject(response.message);
//         }
//       } catch (error: any) {
//         return await Promise.reject(error);
//       }
//     },
//     async updateProfile(data: Update): Promise<any> {
//       try {
//         const response = await authService.updateProfile(data);

//         if (response.data) {
//           return await Promise.resolve(response);
//         } else if (response.response) {
//           return await Promise.reject(response.response);
//         } else {
//           return await Promise.reject(response.message);
//         }
//       } catch (error: any) {
//         return await Promise.reject(error);
//       }
//     },
//   },
// });

// export default authStore;
